export const Bio = {
    name: "Viviane Huguette",
    roles: [
      "Cloud Engineer",
      "Microsoft Azure Engineer"
      
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/khugg",
    resume:
    "https://docs.google.com/document/d/1jifqWL8flZG5xnLYvDgbtGNE48MZc3r4W-vfgLqf5DU/edit?tab=t.0",
    linkedin: "https://www.linkedin.com/feed/",
    


  };
  
  export const skills = [
    {
      title: "Azure Cloud Services",
      skills: [
        {
          name: "Azure Virtual Machines",
          image:
            "https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2F992l7q3goclsz7dnyemr.png",
        },

        {
          name: "Azure Storage",
          image:
            "https://dbmstools.com/images/dbms/azure_blob_storage.png",
        },
        

        {
          name: "Load Balancers",
          image:
            "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiQKAhWWKmin6r4vMGEaDHfBx1-XJbQ-fvVAPvUNOo7tzATwb4xxcnOlCRCblqOurLOZWI3_XARJB0WY4dnhM9VYEcruxKdEtC6t9xgNkzmdiPTNpl_LUAUw6mbwqcXNbVKWLezMYy8-WJq7oGlYtjvtmqmr6CRvaChZWqgzyFfCgaVmZgAjZAZhXrZTsEx/s1600/load-balancer-64c79c1125896-1.webp",
        },


        {
          name: "Entra ID",
          image:
            "https://www.enowsoftware.com/hubfs/Azure-9.png",
        },
        
      
       
      ],
    },
    {
      title: "Infrastructure as Code",
      skills: [
        {
          name: "Terraform",
          image:
            "https://www.aviator.co/blog/wp-content/uploads/2023/01/terraform.png",
        },
        
        {
          name: "ARM Templates",
          image:
            "https://www.varonis.com/hubfs/Imported_Blog_Media/azure-arm-hero-1.png",
        },
        
      ],
    },
    {
      title: "Automation & Scripting",
      skills: [
        {
          name: "PowerShell",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/2/2f/PowerShell_5.0_icon.png",
        },

        {
          name: "Bash",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/4/4b/Bash_Logo_Colored.svg",
        },

        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },

       
      ],
    },



    {
      title: "Monitoring & Logging",
      skills: [
        {
          name: "Azure Monitor",
          image:
            "https://www.cloudsma.com/wp-content/uploads/2020/01/azure_monitor_twitter.png",
        },

        {
          name: "Azure Sentinel",
          image:
            "https://cdn.prod.website-files.com/64e50cbe2b6f932c04238c14/65bd1cf66a489fcb41c89f45_Azure_sentinel_high_res_logo%201.webp",
        },

      ],

      },


      {
        title: "Security & Compliance",
        skills: [
          {
            name: "Azure Firewall",
            image:
              "https://www.lindbergtech.com/content/images/size/w960/2023/08/Azure-firewall.png",
          },
  
          {
            name: "Entra ID",
            image:
              "https://en.wikipedia.org/wiki/Microsoft_Entra_ID#/media/File:Microsoft_Entra_ID_color_icon.svg",
          },
  

          {
            name: "Multi-Factor Authentication (MFA)",
            image:
              "https://portal.cotr.bc.ca/wp-content/uploads/1200x630wa-768x403.png",
          },
  

        ],
  
        },

      


        
      {
        title: "Disaster Recovery & Business Continuity",
        skills: [
          {
            name: "Azure Backup",
            image:
              "https://www.rworks.jp/wp-content/uploads/2021/10/AzureBackup-ttl.png",
          },
  
          {
            name: "Entra ID",
            image:
              "https://en.wikipedia.org/wiki/Microsoft_Entra_ID#/media/File:Microsoft_Entra_ID_color_icon.svg",
          },
        ],
  
        },


      
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Docker",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        },
        {
          name: "Javascript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/9/99/Unofficial_JavaScript_logo_2.svg",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },

        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },

        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        
        
      ],
        
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://ausbestworkplaces2021.economist.com/images/logos/UKG_Logo.png",
      role: "Mid-Level Azure Cloud Engineer",
      company: "UKG Ultimate – Remote.",
      date: "03/2023 – Present",
      desc: "Designed and implemented a multi-region infrastructure with Traffic Manager and Load Balancers, achieving 99.99% availability and minimal latency across regions,Automated infrastructure provisioning with Terraform and ARM templates, reducing deployment times by 60% and minimizing errors, Led security improvements with Azure AD and NSGs to enforce role-based access control, reducing unauthorized access incidents by 40%,Enhanced incident management through Azure Monitor and Log Analytics, integrating alerting workflows via Logic Apps to achieve under 5-minute critical resolution times,Collaborated cross-functionally to establish compliance frameworks for Azure resources, ensuring adherence to corporate security and compliance standards.",

      skills: [
        "Docker",
        "Terraform",
        "AWS",
        "EC2",
        "Portainer",
        "Nginx",
        "JavaScript",
        "TypeScript",
        "Node Js",
        " Next Js",
      ],
      doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
    },
    {
      id: 0,
      img: "https://mcdns.tech/wp-content/uploads/2023/12/logo.svg",
      role: "Azure Cloud Engineer",
      company: "MCdns LLC – Remote",
      date: "02/2022 – 03/2023",
      desc: "Configured and optimized Virtual Machines, Azure Storage, and networking components, improving application performance by 25%,Developed PowerShell scripts for resource automation, reducing manual configuration time by 40%,Implemented cost optimization strategies, resulting in a 30% reduction in spend through reserved instance planning and performance tuning,Established secure VNet architectures and configured Application Gateways to control traffic flow and enhance security,Integrated Azure Sentinel with custom alert rules for proactive monitoring, reducing response time to security incidents by 50%.",
      skills: [
        "ReactJS",
        "Redux",
        "NodeJs",
        "Material UI",
        "HTML",
        "CSS",
        "JavaScript",
      ],
      doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQuw6wwD9bnQdKKTdD77Ci6lmncfiqv1GCiRA&s",
      role: "Junior Azure Cloud Engineer",
      company: "SafeGuard – Atlanta, GA",
      date: "10/2020 – 02/2022",
      desc: "Assisted in managing a hybrid cloud environment, supporting Azure and on-premises resources to ensure seamless connectivity,Configured Azure Backup solutions, achieving a 99.9% data recovery success rate for critical resources,Set up virtual networks (VNets), subnets, and NSGs to improve network isolation and secure Azure-based workloads,Supported Tier-2 troubleshooting for Azure resources, resolving network and storage issues that increased system uptime by 15%,Implemented Azure AD for user identity and access management, centralizing authentication across cloud resources.",
      skills: [
        "ReactJS",
        "Redux",
        "NodeJs",
        "Material UI",
        "HTML",
        "CSS",
        "JavaScript",
        "Docker",
        "AWS",
        "MongoDB",
      ],
    },
    {
      id: 2,
      img: "https://cms.jibecdn.com/prod/incomm/assets/HEADER-LOGO-en-us-1621264464863.png",
      role: "Azure Cloud Operations Associate",
      company: "Incomm Payment – Remote",
      date: "03/2019 – 10/2020",
      desc: "Deployed and maintained scalable microservices in Azure, supporting daily operations for over 400 active users,Reduced costs by 20% through rightsizing VMs and implementing auto-scaling policies based on traffic patterns,Developed and maintained CI/CD pipelines using GitHub Actions, accelerating release cycles by 50%,Built custom dashboards in Azure Monitor to track system health, providing real-time insights that improved response time to issues,Enforced best practices in Azure security, configuring IAM roles, and data encryption to achieve SOC 2 compliance.",
      doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
    },
   
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://logowik.com/content/uploads/images/devry-university3731.jpg",
      school: "DeVry University",
      date: " Expected 03/2025",
      grade: "",
      desc: "I am currently pursuing a Bachelor's degree in IT Science  at DeVry University.",
      degree: "Bachelor of Science in IT",
    },
    {
      id: 1,
      img: "https://learn.microsoft.com/en-us/media/learn/certification/badges/microsoft-certified-associate-badge.svg",
      school: "MICROSOFT",
      date: "",
      grade: "",
      desc: "",
      degree: "Microsoft Certified: Azure Administrator (AZ-104)",
    },
    {
      id: 2,
      img: "https://learn.microsoft.com/en-us/media/learn/certification/badges/microsoft-certified-associate-badge.svg",
      school: "MICROSOFT",
      date: "",
      grade: "",
      desc: "",
      degree: "Azure Security Engineer (AZ-500)",
    },

    {
      id: 2,
      img: "https://learn.microsoft.com/en-us/media/learn/certification/badges/microsoft-certified-associate-badge.svg",
      school: "MICROSOFT",
      date: "",
      grade: "",
      desc: "",
      degree: "Azure Solutions Architect Expert (AZ-305)",
    },

  ];
  
  export const projects = [
    {
      id: 9,
      title: "Scalable infrastructure",
      date: "Dec 2024 - jan 2025",
      description:
        "scalable infrastructure on Azure to host their customer-facing web application, expected to see high traffic.",
      image:
        "https://spacelift.io/_next/image?url=https%3A%2F%2Fspaceliftio.wpcomstaging.com%2Fwp-content%2Fuploads%2F2023%2F03%2Fscalable-infra-benefits.png&w=1920&q=75",
      tags: [
        "Azure monitor",
        "Azure Storage",
        "Azure Virtual Machines",
        "Azure Backup",
        "Azure Firewall",
        "Identity and Access Management",
        "Azure AD",
        "cost management",
        "Azure Monitor",
        "Power Automate",
        
      ],
      category: "automation",
      github: "https://github.com/khugg/khugg.github.io",
      webapp: " https://khugg.github.io",
    },
    
    
    {
      id: 0,
      title: "Azure Automation",
      date: "Dec 2024 - Jul 2025",
      description:
        "Azure Automation provides tools to manage your cloud and on-premises infrastructure seamlessly..",
      image:
        "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*1GuzW9lbE3-eW_B92XJnNA.png",
      tags: [ "Azure monitor",
        "Power apps",
        "Power Automate",],

        
      category: "automation",
      github: "https://github.com/khugg/khugg.github.io",
      webapp: " https://khugg.github.io",
    },
    {
      id: 1,
      title: "Azure SQL Database Monitoring",
      date: "Dec 2024 - Jul 2025",
      description:
        "A single pane of glass to look at your Azure databases and your on-premises servers at the same time.",
      image:
        "https://www.hugobarona.com/monitoring-azure-sql-database-effectively-in-2022/featured-image.png",
      tags: ["Metrics Explorer", "Log Analytics"],
      category: "monitoring",
      github: "https://github.com/khugg/khugg.github.io",
      webapp: " https://khugg.github.io",
    },
   
    {
      id: 2,
      title: "ViviFolio",
      date: "Nov 2024",
      description:
        "My portfolio website  showcases my best work.",
      image:
        "https://github.com/user-attachments/assets/06791603-4d08-4fcf-bf79-5e8cd37dccec",
      tags: ["React Js", "github","Node JS"],
      category: "portfolio website",
      github: "https://github.com/khugg/FinTechEdge-Terraform-VMSS-Traffic-Manager-AzureFirewall",
      webapp: " https://khugg.github.io",
    },






    {
      id: 2,
      title: "Devops",
      date: "Dec 2024 - Jul 2025",
      description:
        " DevOps is a combination of software development (dev) and operations (ops). It is defined as a software engineering methodology which aims to integrate the work of development teams and operations teams by facilitating a culture of collaboration and shared responsibility.",
      image:
        "https://cdn.prod.website-files.com/5ff66329429d880392f6cba2/63cf9397b481dfe16fa67459_DevOps%20definition.png",
      tags: ["Docker", "Kurbenetes", "Git", "Ansible"],
      category: "Devops",
      github: "https://github.com/khugg/FinTechEdge-Terraform-VMSS-Traffic-Manager-AzureFirewall",
      webapp: " https://khugg.github.io",
    },

   



   
  ];
  
  export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
  ];